import React from 'react';
import Modal from 'react-responsive-modal';

export const PlacesModal = props => {
	let headerName = '1-800-Battery';
	if (props.masterProvider && props.masterProvider.isActive) {
		headerName = props.masterProvider.name;
	}

	return (
		<Modal
			classNames={{
				modal: 'location-permission-modal',
				closeButton: 'close-btn',
			}}
			open={props.isOpen}
			onClose={props.onCloseModal}>
			<div className="inner">
				<h3>{`Hi, it's ${headerName}`}</h3>
				<p>
					We would love to help you, but first we need to know where you are at. Our products and service
					availability are dependent on where you are located.
				</p>

				{props.isGeolocationEnabled ? (
					<div className="buttons">
						<button
							disabled={props.locationPermissionApprovedLoading}
							className={`btn btn-success ${props.locationPermissionApprovedLoading ? 'disabled' : ''}`}
							onClick={() => props.getCurrentLocation()}>
							<i
								className={
									props.locationPermissionApprovedLoading
										? 'fas fa-circle-notch fa-spin'
										: 'fas fa-map-marker-alt'
								}></i>
							{' Yes. Use My Location.'}
						</button>
					</div>
				) : (
					''
				)}
				{props.isGeolocationEnabled ? (
					<div className="or-container mt-2 mb-2">
						<div className="line"></div>
						<div>
							<span>OR</span>
						</div>
						<div className="line"></div>
					</div>
				) : (
					''
				)}

				{!props.isGeolocationEnabled && props.isGeolocationAvailable ? (
					<div className="or-container mt-2 mb-2">
						<div className="line"></div>
						<div>
							<span>My Location is:</span>
						</div>
						<div className="line"></div>
					</div>
				) : (
					''
				)}

				<div className="place-selection extended">
					{props.loadingCurrentGeolocation && (
						<span className={`input-loading-status`}>
							<i className="fas fa-circle-notch fa-spin"></i>Loading your location...
						</span>
					)}
					{props.children}
				</div>
			</div>
		</Modal>
	);
};
